module.exports = __webpack_public_path__ + "static/media/Northern_Peninsula.f7cfb1c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Northern_Peninsula.jpg
// module id = 650
// module chunks = 0